import { apiGetCreatorReferral } from '~/lib/api/marketplace';
import { classNames } from '~/utils/classNames';
import { CARD, CopyField, LoadError, Section, SkeletonCard } from '~/components/workbench/tools/payments/ui';
import { useResource } from '~/components/workbench/tools/payments/use-resource';
import { formatUsd, referralTerms } from '~/components/marketplace/developer-model';

/** Your referral link: you earn a share of what the customers you bring spend. */
export function ReferralCard() {
  const referral = useResource(() => apiGetCreatorReferral(), 'creator-referral');
  const r = referral.data;

  return (
    <Section title="Referrals" icon="i-ph:share-network">
      {referral.error ? (
        <LoadError message="Could not load your referral link." onRetry={() => void referral.reload()} />
      ) : !r ? (
        <SkeletonCard lines={2} />
      ) : (
        <div className={classNames(CARD, 'space-y-3 p-4')}>
          <p className="text-[12px] leading-relaxed text-secondary">
            Earn {referralTerms(r)} when someone joins Dunea from your link. Your template remixes and listing pages
            carry it too.
          </p>
          <CopyField label="Your link" value={r.link} />
          <dl className="grid grid-cols-3 gap-2">
            <Count label="Signups" value={String(r.signups)} />
            <Count label="Paying" value={String(r.paying)} />
            <Count label="Earned" value={formatUsd(r.earned)} />
          </dl>
        </div>
      )}
    </Section>
  );
}

function Count({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-0">
      <dt className="truncate text-[10.5px] text-muted">{label}</dt>
      <dd className="mt-0.5 text-[15px] leading-none text-primary [font-variant-numeric:tabular-nums]">{value}</dd>
    </div>
  );
}
